module.exports = __webpack_public_path__ + "static/media/breakdown.499a9513.webp";